export enum IncomingChatMessageStatusEnum {
    NOTIFICATION = 0,
    RECEIVED = 1,
    MUST_CONFIRM = 2,
    CONFIRMED = 3,
    ERROR = 4
  }


  
  export enum OutgoingChatMessageStatusEnum {
    NOTIFICATION = 0,
    RECEIVED = 1,
    MUST_CONFIRM = 2,
    CONFIRMED = 3,
    ERROR = 4
  }

